import Text from '@cartwhl/ui/base/Text';

import type {
  ProfileSection,
  ProfileSectionSlug,
} from './profilePageSections';

export interface ProfileDesktopNavProps {
  sections: ProfileSection[];
  activeSlug?: ProfileSectionSlug;
  className?: string;
  onSelect: (slug: ProfileSectionSlug) => void;
}

export default function ProfileDesktopNav({
  sections,
  activeSlug,
  className,
  onSelect,
}: ProfileDesktopNavProps) {
  if (sections.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="Profile sections"
      className={`mt-1.5 flex w-[180px] flex-none flex-col gap-2 ${className ?? ''}`}
    >
      {sections.map((section) => {
        const isActive = section.slug === activeSlug;

        return (
          <button
            key={section.slug}
            type="button"
            aria-current={isActive ? 'page' : undefined}
            className={`hover:bg-gray-15 dark:hover:bg-gray-60 flex h-10 w-full items-center rounded-lg px-4 pt-0.5 text-left transition-colors ${
              isActive
                ? 'bg-gray-15 hover:bg-gray-15 dark:bg-gray-75 dark:hover:bg-gray-75 cursor-default'
                : ''
            }`}
            onClick={() => onSelect(section.slug)}
          >
            <Text variant="studio/body/medium/sm">{section.label}</Text>
          </button>
        );
      })}
    </nav>
  );
}
